//require('./bootstrap');

import { createApp } from 'vue';

import LoginComponent from './components/auth/LoginComponent';
import HomeComponent from './components/HomeComponent';
import UserComponent from './components/UserComponent';
import ClientesComponent from './components/ClientesComponent';
import WebsitesComponent from './components/WebsitesComponent';
import PedidosComponent from './components/PedidosComponent';
import PedidosAdministradorComponent from './components/PedidosAdministradorComponent';
import PropietariosComponent from './components/PropietariosComponent';
import RedactoresComponent from './components/RedactoresComponent';
import RedaccionesComponent from './components/RedaccionesComponent';
import PublicationFollowUpsComponent from './components/PublicationFollowUpsComponent';

const appScript = Array.from(document.scripts).find(script => /\/js\/app\.js(?:\?|$)/.test(script.src));

if (appScript) {
    __webpack_public_path__ = appScript.src.replace(/js\/app\.js(?:\?.*)?$/, '');
}

const app = createApp({
    components: {
        LoginComponent,
        HomeComponent,
        UserComponent,
        ClientesComponent,
        WebsitesComponent,
        PedidosComponent,
        PedidosAdministradorComponent,
        PropietariosComponent,
        RedactoresComponent,
        RedaccionesComponent,
        PublicationFollowUpsComponent
    }
});

const root = document.querySelector('#app');
const componentSelector = [
    'home-component',
    'clientes-component',
    'websites-component',
    'pedidos-component',
    'pedidos-administrador-component',
    'propietarios-component',
    'redactores-component',
    'redacciones-component',
    'publication-follow-ups-component'
].join(',');

if (root && root.querySelector(componentSelector)) {
    app.mount(root);
}
